<template>
  <v-container class="bigger" :class="{ 'personal-container': $vuetify.breakpoint.mdAndUp }">
    <app-loading :loading="loading">
      <div>
        <template v-if="currentExercise && currentExercise.ex_type">
          <component
            :is="currentExercise.ex_type"
            :data="currentExercise"
            :key="currentExercise.uuid"
            @finished="onFinished"
            @already-finished="onAlreadyFinished"
            @next-exercise="onNext"
            @reset="onReset"
          ></component>
        </template>
        <app-comment-group
          :uuid="currentExercise.comment_group"
          :key="currentExercise.comment_group"
        />
        <app-student-note v-if="!isTeacher && qualification.note" :note="qualification.note" />
        <app-qualification
          v-if="isTeacher && !qualification.note && qualification.uuid"
          :qualification="qualification"
          @new-qual="qualification = $event"
        />
      </div>
    </app-loading>
  </v-container>
</template>
<script>
import Qualification from "@/components/Utils/Qualification.vue";
import StudentNote from "@/components/Utils/StudentNote.vue";
import studentMixin from "@/mixins/studentMixin";
import Loading from "@/components/Loading.vue";
import { patchLessonProgress } from "@/api/api";
import CommentGroup from "./components/CommentGroup.vue";

export default {
  components: {
    appQualification: Qualification,
    appLoading: Loading,
    appStudentNote: StudentNote,
    appCommentGroup: CommentGroup,
  },
  mixins: [studentMixin],
  data() {
    return {
      index: 1,
      loading: true,
      qualifications: [],
      qualification: {},
      currentExercise:
        this.$store.getters["lesson/grammar"].exercises[
          Number(this.$route.params.index || 1) - 1
        ],
    };
  },
  computed: {
    exercises() {
      return this.$store.getters["lesson/grammar"].exercises;
    },
  },
  watch: {
    "$route.params.index"(value) {
      this.index = value;
      this.qualification = this.qualifications[value - 1];
      this.currentExercise = this.exercises[value - 1];
    },
  },
  methods: {
    onReset() {
      this.qualifications[this.index - 1] = {};
      this.qualification = {};
    },
    async onNext() {
      if (this.exercises.length === this.index) {
        this.$router.push({ name: "exercise", params: { index: 1 } });
      } else
        this.$router.push({
          name: "exercise",
          params: { index: this.index + 1 },
        });
    },
    updateProgress() {
      let progress = this.$store.getters["progress/lesson"];
      const exercise = progress.grammar_progress.exercises.find(
        (element) => element.exercise === this.currentExercise.uuid,
      );
      if (!exercise.completed) {
        exercise.completed = true;
        patchLessonProgress(progress).then((response) => {
          this.$store.commit("progress/lesson", response.data);
        });
      }
    },
    async onAlreadyFinished() {
      this.updateProgress();
    },
    async onFinished() {
      this.updateProgress();
      this.qualification = await this.qualify();
      this.qualifications.splice(this.index - 1, 1, this.qualification);
    },
  },
  async created() {
    this.index = this.$route.params.index;
    this.loading = true;
    for (let index = 0; index < this.exercises.length; index++) {
      const element = this.exercises[index];
      const response = await this.fetchQualification(
        this.student.email,
        element.question_group.uuid,
      );
      this.qualifications.push(response);
    }
    if (this.qualifications[0] && !this.qualify.student) {
      this.qualification = this.qualifications[0];
    }

    this.exercises.forEach((element) => {
      if (!this.$options.components[element.ex_type]) {
        this.$options.components[element.ex_type] = () =>
          import(`@/components/Lessons/Lesson/Grammar/${element.ex_type}.vue`);
      }
    });
    this.loading = false;
  },
};
</script>
<style scoped>
.personal-container {
  padding-left: 87px !important;
  padding-right: 88px !important;
}
.bigger {
  padding-top: 3% !important;
}
</style>
